import { useTranslation } from "react-i18next"

export const useSkeletonStatusProps = () => {
  const { t } = useTranslation()

  return {
    role: "status" as const,
    "aria-busy": "true" as const,
    "aria-label": t("defaultTranslations.loading"),
  }
}
